import { callFunction } from "./functions-client";

// In-app 1:1 messaging (MVP).

export interface Conversation {
  id: string;
  other_name: string;
  last_message: string | null;
  last_message_at: string;
  last_message_from_me?: boolean;
}

export interface Message {
  id: string;
  sender_id: string;
  body: string;
  created_at: string;
  audio_url?: string | null; // signed URL for a voice note, when present
}

export const listConversations = () =>
  callFunction<{ conversations: Conversation[] }>("messaging/conversations", { method: "GET" });

export const listMessages = (conversationId: string) =>
  callFunction<{ messages: Message[]; me: string }>(
    `messaging/messages?conversation_id=${encodeURIComponent(conversationId)}`,
    { method: "GET" },
  );

export const sendMessage = (input: { profile_id?: string; conversation_id?: string; body?: string; audio_path?: string }) =>
  callFunction<{ conversation_id: string; message: Message }>("messaging/send", { body: input });

// Voice notes (LOS Phase 20 M4): get a signed upload URL for an audio attachment in a
// conversation, then PUT the audio and send a message referencing the returned path.
export const voiceUploadUrl = (input: { profile_id?: string; conversation_id?: string }) =>
  callFunction<{ conversation_id: string; path: string; upload_url: string }>("messaging/voice-upload-url", { body: input });
